import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/app/store";
import { clearSession, readSession, writeSession } from "@/shared/api/session";

export interface SessionState {
  token: string | null;
  apiKey: string | null;
  /** `chosenLanguage` del legacy: vive solo nello store, non e' persistito. */
  localeChosen: boolean;
}

const initialState = (): SessionState => ({ ...readSession(), localeChosen: false });

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    signedIn(state, action: PayloadAction<{ token: string; apiKey: string }>) {
      writeSession(action.payload);
      state.token = action.payload.token;
      state.apiKey = action.payload.apiKey;
    },
    signedOut(state) {
      clearSession();
      state.token = null;
      state.apiKey = null;
    },
    /** 401/403 dal backend: stessa cosa del logout, ma originata dal server. */
    sessionExpired(state) {
      clearSession();
      state.token = null;
      state.apiKey = null;
    },
    /**
     * Rilegge localStorage. La Login ora dispatcha `signedIn`; questa azione resta per i test e per lo
     * storage scritto da versioni precedenti, e va rimossa in fase 8.
     */
    sessionRestored(state) {
      const stored = readSession();
      state.token = stored.token;
      state.apiKey = stored.apiKey;
    },
    localeChosen(state) {
      state.localeChosen = true;
    },
  },
});

export const { signedIn, signedOut, sessionExpired, sessionRestored, localeChosen } = sessionSlice.actions;
export const selectSession = (state: RootState): SessionState => state.session;
export const selectIsAuthenticated = (state: RootState): boolean => Boolean(state.session.token);
export const selectLocaleChosen = (state: RootState): boolean => state.session.localeChosen;
